<div class="row">
  <div class="col-md-2">
    <p-panelmenu [model]="catList" status="primary"></p-panelmenu>
  </div>
  <div class="col-md-10">
    <router-outlet></router-outlet>
  </div>
</div>
